<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :actions="actions"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      ref="grid"
    ></dx-grid>

    <v-dialog persistent v-model="updateDialog" max-width="900">
      <v-card>
        <v-card-title class="headline green white--text py-3"
          >Kesher Feedback Message #{{ rowClicked.id }}</v-card-title
        >

        <v-card-text class="pt-3">
          <v-layout row wrap>
            <v-flex xs12 md6 class="pr-3">
              <div
                class="pa-3"
                style="border: 1px solid #e0e0e0; border-radius: 4px; background-color: #fafafa; height: 100%;"
              >
                <div class="caption grey--text mb-2">CALLER INFORMATION</div>

                <v-layout row class="mb-2">
                  <v-flex
                    xs4
                    class="font-weight-medium grey--text text--darken-1"
                    >Name:</v-flex
                  >
                  <v-flex xs8>{{ rowClicked.name }}</v-flex>
                </v-layout>

                <v-layout row class="mb-2" v-if="rowClicked.nameH">
                  <v-flex
                    xs4
                    class="font-weight-medium grey--text text--darken-1"
                    >Hebrew:</v-flex
                  >
                  <v-flex xs8>{{ rowClicked.nameH }}</v-flex>
                </v-layout>

                <v-layout row class="mb-2" v-if="rowClicked.accountID">
                  <v-flex
                    xs4
                    class="font-weight-medium grey--text text--darken-1"
                    >Account:</v-flex
                  >
                  <v-flex xs8>{{ rowClicked.accountID }}</v-flex>
                </v-layout>

                <v-layout row class="mb-2" v-if="rowClicked.callerID">
                  <v-flex
                    xs4
                    class="font-weight-medium grey--text text--darken-1"
                    >Phone:</v-flex
                  >
                  <v-flex xs8>{{ rowClicked.callerID }}</v-flex>
                </v-layout>

                <v-layout row class="mb-2" v-if="rowClicked.type">
                  <v-flex
                    xs4
                    class="font-weight-medium grey--text text--darken-1"
                    >Type:</v-flex
                  >
                  <v-flex xs8>{{ rowClicked.type }}</v-flex>
                </v-layout>

                <v-layout row class="mb-2" v-if="rowClicked.date">
                  <v-flex
                    xs4
                    class="font-weight-medium grey--text text--darken-1"
                    >Date:</v-flex
                  >
                  <v-flex xs8>{{ rowClicked.date | dateTime }}</v-flex>
                </v-layout>

                <div v-if="rowClicked.recording" class="mt-3">
                  <div class="caption grey--text mb-1">RECORDING</div>
                  <audio
                    :src="rowClicked.recording"
                    controls
                    style="width: 100%; height: 30px;"
                  ></audio>
                </div>

                <div class="mt-2">
                  <div class="caption grey--text mb-1">NOTE</div>
                  <v-textarea
                    outline
                    class="mt-0"
                    hide-details
                    placeholder="Add a note..."
                    v-model="rowClicked.note"
                    rows="2"
                  ></v-textarea>
                </div>
              </div>
            </v-flex>

            <v-flex xs12 md6 class="pl-3">
              <div
                class="pa-3"
                style="border: 1px solid #e0e0e0; border-radius: 4px; height: 100%;"
              >
                <div class="caption grey--text mb-2">UPDATE STATUS</div>

                <v-select
                  outline
                  class="mb-3"
                  label="Status"
                  :items="statusOptions"
                  v-model="rowClicked.status"
                  hide-details
                ></v-select>

                <v-textarea
                  class="mb-0"
                  hide-details
                  label="Complete Note"
                  placeholder="Required when completing..."
                  v-model="rowClicked.completeNote"
                  rows="13"
                  outline
                  :required="rowClicked.status === 'COMPLETED'"
                ></v-textarea>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="px-3 py-3 mr-0">
          <v-spacer></v-spacer>
          <v-btn dark color="grey" @click="closeDialog()">Close</v-btn>
          <v-btn
            :loading="processing"
            color="success"
            @click="updateFeedback()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data: () => ({
    title: "Kesher Feedback Messages",
    columns: [
      {
        field: "statusIcon",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
        },
        icon: (value) => {
          switch (value) {
            case "COMPLETED":
              return "mdi-check-circle";
            case "OPEN":
              return "mdi-clock-outline";
            default:
              return "mdi-circle-outline";
          }
        },
        iconColor: (value) => {
          switch (value) {
            case "COMPLETED":
              return "success";
            case "OPEN":
              return "#fdb400";
            default:
              return "#aeb8bf";
          }
        },
      },
      {
        label: "ID",
        field: "id",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Hebrew Name",
        field: "nameH",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Account ID",
        field: "accountID",
        link: "Account View",
        format: "",
        template: "link-cell-template",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Employee ID",
        field: "employeeID",
        visible: true,
        link: "TeacherView",
        template: "link-cell-template",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Date",
        field: "date",
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        visible: true,
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Phone",
        field: "callerID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Type",
        field: "type",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Recording",
        field: "recording",
        template: "link-audio-cell-template",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Status",
        field: "status",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Completed At",
        field: "completedAt",
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Completed By",
        field: "completedBy",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Note",
        field: "note",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Complete Note",
        field: "completeNote",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],

    actions: [],
    processing: false,
    rowClicked: {},
    updateDialog: false,
    statusOptions: ["OPEN", "COMPLETED"],
    url: "kesherFeedbackMessages?includeCompleted=false",
  }),

  async created() {
    this.actions.push({
      text: "Show Completed",
      type: "switch",
      action: this.onShowCompletedChanged,
    });

    if (this.$route.query.id) {
      const message = await this.$http.get(
        "api/KesherFeedbackMessages/GetByID?id=" + this.$route.query.id
      );

      this.onRowClicked(message);
    }
  },

  methods: {
    onShowCompletedChanged(value) {
      this.url = `kesherFeedbackMessages?includeCompleted=${value}`;
      this.$refs.grid.reloadDataSource(this.url);
    },

    onRowClicked(row) {
      this.rowClicked = JSON.parse(JSON.stringify(row));
      this.updateDialog = true;
    },

    closeDialog() {
      this.rowClicked = {};
      this.updateDialog = false;
    },

    async updateFeedback() {
      if (!this.rowClicked.status) {
        this.$notify({
          group: "notification",
          text: "Status is required",
          type: "error",
        });
        return;
      }

      if (
        this.rowClicked.status === "COMPLETED" &&
        !this.rowClicked.completeNote
      ) {
        this.$notify({
          group: "notification",
          text: "Complete Note is required when marking as completed",
          type: "error",
        });
        return;
      }

      this.processing = true;

      try {
        await this.$http.post("api/KesherFeedbackMessages/UpdateFeedback", {
          id: this.rowClicked.id,
          note: this.rowClicked.note,
          completeNote: this.rowClicked.completeNote,
          status: this.rowClicked.status,
          user: this.$store.state.authentication.user,
        });

        this.$notify({
          group: "notification",
          text: "Feedback updated successfully",
          type: "success",
        });

        this.processing = false;
        this.updateDialog = false;
        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
  },

  filters: {
    dateTime(value) {
      if (!value) return "";
      return moment(value).format("MM/DD/YYYY hh:mm:ss A");
    },
  },
};
</script>

<style scoped>
.width-25 {
  width: 25px;
}
</style>
